import { createSlice } from "@reduxjs/toolkit";
import { fundersAPI } from "../../../api/publicApi";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const fundersSlice = createSlice({
  name: "funders",
  initialState: data,
  reducers: {
    fundersSlice(state) {
      state.isLoading = false;
    },
    fundersSliceSuccess(state, action) {
      state.isLoading = true;
      state.data = action.payload;
      state.message = null;
    },
    fundersSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    fundersSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const fundersHandler = () => async (dispatch: any) => {
  try {
    dispatch(fundersAction.fundersSlice());
    const response: any = await fundersAPI();
    dispatch(fundersAction.fundersSliceSuccess(response));
  } catch (e: any) {
    dispatch(fundersAction.fundersSliceFailure(e?.response?.data?.message));
    dispatch(fundersAction.fundersSliceReset());
  }
};
export default fundersSlice.reducer;
export const fundersAction = fundersSlice.actions;
